import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { AppInfoService } from 'core/app-info/app-info.service';
import { FeaturedProduct } from '../products/entities/product-entity';
import { ProductsService } from '../products/services/products-service/products.service';
import { AppLocalization } from '../../shared/entities/app-localization';

@Component({
  selector: 'app-featured-products',
  templateUrl: './featured-products.component.html',
  styleUrls: ['./featured-products.component.scss'],
  standalone: false
})
export class FeaturedProductsComponent implements OnInit {
  featureProds: FeaturedProduct[];
  isLoading: boolean;
  appStrings: AppLocalization;
  page = [];
  totalRecords: number;
  pageSize = 12;
  currentPage = 0;
  noImage;

  formFields = {
    searchField: '',
  };
  searchInput = this.fb.group(this.formFields);

  constructor(
    private productsService: ProductsService,
    private appInfoService: AppInfoService,
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    // TODO Uncomment when featured products is implmented
    this.isLoading = true;
    this.appStrings = this.appInfoService.appStrings;
    this.noImage = this.productsService.noImage;
    // this.productsService.getFeaturedProducts(this.selectedCatalogCode, (featureProds: FeaturedProduct[]) => {
    //   this.featureProds = featureProds;
    //   this.totalRecords = this.featureProds.length;
    //   this.page = this.featureProds.slice(0, this.pageSize);
    //   this.isLoading = false;
    // });
  }

  loadPage(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.page = this.featureProds.slice(event.pageIndex * this.pageSize, event.pageIndex * this.pageSize + this.pageSize);
  }

}
